// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2D4K5","search":"Settings_search__NlmlK","filter":"Settings_filter__2HmLW"};